/**
 * procedureHours.ts — legacy's Hours choice for a procedure row (quotes and
 * membership / package templates): an hour band of a facility's OR-fee scale.
 */

/**
 * Legacy's hour choice: the first band at or above the procedure's expected
 * hours, or the largest band when the procedure is longer than the whole scale
 * (quote-procedures-display-new.php:276-283 — the loop breaks on the first
 * `>=` and otherwise leaves the last option selected). Expected 0 stays 0,
 * matching legacy's `$hours != '0'` guard.
 */
export function bandFor(expected: number, bands: number[]): number {
  if (!(expected > 0)) return 0;

  // No scale to snap to — mid-fetch, a failed request, or a quote with no
  // facility yet. Keep the catalog's own hours rather than returning 0:
  // rateScaleFees short-circuits to [0, 0] at totalHours <= 0, so zeroing here
  // would quietly price the anaesthesia and OR lines at nothing.
  if (bands.length === 0) return expected;

  // The first band that COVERS the procedure, else the largest. This mirrors
  // the pick path (quote-handling-ds.js:503-509), where selectedIndex is
  // assigned before the >= test so an over-scale procedure leaves the last
  // option selected. Legacy's PHP render path resolves an over-scale value to
  // 0 instead; that governs page load, not choosing a procedure.
  return bands.find((b) => b >= expected) ?? bands[bands.length - 1];
}
